import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none'
    }
  }
}))

export default useStyles
